<template>
  <div class="posting-detail-field">
    <label>{{ label }}</label>
    <template v-if="field.length">
      <div
        v-for="fieldItem in field"
        :key="fieldItem"
      >
        <CAlert
          color="info"
          :class="{ 'background': inline }"
        >
          {{ fieldItem }}
        </CAlert>
      </div>
    </template>
    <PostingDetailSupport v-else />
  </div>
</template>

<script>
import PostingDetailSupport from './PostingDetailSupport.vue'

export default {
  name: 'PostingDetailMultiField',
  components: {
    PostingDetailSupport
  },
  props: {
    field: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    inline: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.background {
      background-color: #ebf2fe;
      padding: 8px;
      border-radius: 4px;
      display: inline-block;
}
</style>
